import { bindRequestLogic } from './utils'
import MessageTypes from '../actionTypes/message'
import { messageAPI, messageImportAPI } from '../api'

const getMessages = bindRequestLogic({
  clientFunc: messageAPI.getMessages,
  type: MessageTypes.GET_MESSAGES_REQUEST,
  successType: MessageTypes.GET_MESSAGES_SUCCESS,
  failType: MessageTypes.GET_MESSAGES_FAILED,
  isQueryParam: true,
  modelName: 'messages'
})

const createMessage = bindRequestLogic({
  clientFunc: messageAPI.createMessage,
  type: MessageTypes.CREATE_MESSAGE_REQUEST,
  successType: MessageTypes.CREATE_MESSAGE_SUCCESS,
  failType: MessageTypes.CREATE_MESSAGE_FAILED
})

const deleteMessage = bindRequestLogic({
  clientFunc: messageAPI.deleteMessage,
  type: MessageTypes.DELETE_MESSAGE_REQUEST,
  successType: MessageTypes.DELETE_MESSAGE_SUCCESS,
  failType: MessageTypes.DELETE_MESSAGE_FAILED
})

const updateMessages = bindRequestLogic({
  clientFunc: messageAPI.updateMessages,
  type: MessageTypes.UPDATE_MESSAGES_REQUEST,
  successType: MessageTypes.UPDATE_MESSAGES_SUCCESS,
  failType: MessageTypes.UPDATE_MESSAGES_FAILED
})

const importMessages = bindRequestLogic({
  clientFunc: messageImportAPI.importMessages,
  type: MessageTypes.IMPORT_MESSAGES_REQUEST,
  successType: MessageTypes.IMPORT_MESSAGES_SUCCESS,
  failType: MessageTypes.IMPORT_MESSAGES_FAILED
})

const getSystemMessages = bindRequestLogic({
  clientFunc: messageAPI.getSystemMessages,
  type: MessageTypes.GET_SYSTEM_MESSAGES_REQUEST,
  successType: MessageTypes.GET_SYSTEM_MESSAGES_SUCCESS,
  failType: MessageTypes.GET_SYSTEM_MESSAGES_FAILED,
  isQueryParam: true
})

export default [
  getMessages,
  createMessage,
  deleteMessage,
  updateMessages,
  importMessages,
  getSystemMessages
]
